module.exports = __webpack_public_path__ + "img/004.a90df823.png";